import { ProductLineName } from '@/components/modals/SubmitOrder/types';
import { selectProposal } from '@/store/reducers/proposals/selectors';
import { AppState, PriceBookEntryVm, ProposalType } from '@/types';

export const selectDesignToOrderProducts = (state: AppState): PriceBookEntryVm[] => {
  return state.products.designToOrderEntries;
};

export const selectProductLineName = (state: AppState): ProductLineName | null => {
  const proposal = selectProposal(state);

  if (!proposal) {
    return null;
  }

  return proposal.proposalType === ProposalType['Timberline Solar']
    ? 'Timberline Solar™'
    : 'Decotech®';
};
